const React = require('react')
const PropTypes = require('prop-types')
const BreadcrumbIcon = require('@assets/icons/breadcrumb.svg')

const Breadcrumb = ({ items }) => {
    return (
        <nav aria-label='breadcrumb'>
            <ol className='breadcrumb'>
                <li className='breadcrumb-item'>
                    <img src={BreadcrumbIcon} alt='Breadcrumb Icon' />
                </li>
                {items.map((item, index) => (
                    <li key={index} className='breadcrumb-item'>
                        <a href={item.to}>{item.text}</a>
                    </li>
                ))}
            </ol>
        </nav>
    )
}

Breadcrumb.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            to: PropTypes.string.isRequired
        })
    ).isRequired
}

module.exports = {
    Breadcrumb
}
